import { array, intersect, partial, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as PropertyType } from '../../../../whole-house/material/property-type';
import { Id as UsageId } from '../../../../whole-house/usage/Id';

export const Request = intersect(
	struct({
		propertyTypes: array(PropertyType),
	})
)(
	partial({
		materialTemplateRef: iotsUtils.NotEmptyString,
		usages: array(UsageId),
	})
);
